export default __webpack_public_path__ + "static/3-24b1e1e4859a69fb7890a397f08a020c.png";